import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { AppStore } from "@/store";
import VueI18n from "vue-i18n";
import { generateI18n } from "@/messages/i18n";
import { setupValidation } from "@/validation/validation";

Vue.use(VueI18n);
const locale = navigator.language.split("-")[0];
const i18n = generateI18n(locale);
setupValidation(i18n);

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.prototype.$store = new AppStore({
  surveyForm: {
    surveyId: "",
    hashCode: "",
    createdDateTime: "",
    updatedDateTime: "",
    title: [],
    details: [],
    langs: [],
    qrPrefix: "",
    qrAnswerDate: false,
    surveyItems: []
  }
});

new Vue({
  router,
  vuetify,
  render: h => h(App),
  i18n
}).$mount("#app");
